module.exports = __webpack_public_path__ + "img/icon09.700ea1bf.png";